const template = () => `
<div class="loading loading--whiteout">
        <div class="loading__spinner"></div>
    </div>
`
export default template
